import { Button, Modal } from "react-bootstrap";
import ApproveTopup from "./ApproveTopup";

const ApproveTopupModal = ({
  title,
  handleClose,
  show,
  data,
  refetchRequestList,
}) => {
  return (
    <Modal className="fade" show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <ApproveTopup
          handleClose={handleClose}
          data={data}
          refetchRequestList={refetchRequestList}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ApproveTopupModal;
